// frontend/src/constants/paymentGateways.js
// Shared across admin + checkout so logos only live in one place.

export const PAYMENT_GATEWAYS = {
  payflex: {
    id: "payflex",
    name: "Payflex",
    description: "Buy now and pay later in interest-free instalments",
    fallbackIcon:
      "https://via.placeholder.com/120x120/5B2C83/FFFFFF?text=Payflex",
    type: "redirect",
    color: "#5B2C83",
  },
  payfast: {
    id: "payfast",
    name: "PayFast",
    description: "Credit/Debit Card, Instant EFT, Mobicred",
    icon: "https://dialanerd.co.za/wp-content/uploads/2016/09/PayFast-Logo-Colour.png",
    fallbackIcon:
      "https://via.placeholder.com/120x120/0066B3/FFFFFF?text=PayFast",
    type: "redirect",
    color: "#0066B3",
  },
  yoco: {
    id: "yoco",
    name: "Yoco",
    description: "Credit and Debit Card processing",
    icon: "https://a.storyblok.com/f/111633/2400x1260/81bddfa73a/yoco-logo-blue.jpg",
    fallbackIcon: "https://via.placeholder.com/120x120/00B4D8/FFFFFF?text=Yoco",
    type: "direct",
    color: "#00B4D8",
  },
  ozow: {
    id: "ozow",
    name: "Ozow",
    description: "Instant EFT via major South African banks",
    icon: "https://cdn.prod.website-files.com/6283605e6ac07b4da2c53ce3/6283605e6ac07b724dc53d7d_logo.png",
    fallbackIcon: "https://via.placeholder.com/120x120/FF6B00/FFFFFF?text=Ozow",
    type: "redirect",
    color: "#FF6B00",
  },
  paypal: {
    id: "paypal",
    name: "PayPal",
    description: "Pay with PayPal balance or international cards",
    icon: "https://www.paypalobjects.com/webstatic/mktg/logo/pp_cc_mark_37x23.jpg",
    fallbackIcon:
      "https://via.placeholder.com/120x120/003087/FFFFFF?text=PayPal",
    type: "redirect",
    color: "#003087",
  },
  stripe: {
    id: "stripe",
    name: "Stripe",
    description: "Credit/Debit Card, Apple Pay, Google Pay",
    icon: "https://stripe.com/img/v3/home/social.png",
    fallbackIcon:
      "https://via.placeholder.com/120x120/635BFF/FFFFFF?text=Stripe",
    type: "direct",
    color: "#635BFF",
  },
  flutterwave: {
    id: "flutterwave",
    name: "Flutterwave",
    description: "Cards, Bank Transfer, Mobile Money across Africa",
    icon: "https://upload.wikimedia.org/wikipedia/commons/9/9e/Flutterwave_Logo.png",
    fallbackIcon:
      "https://via.placeholder.com/120x120/F5A623/FFFFFF?text=Flutterwave",
    type: "redirect",
    color: "#F5A623",
  },
  paystack: {
    id: "paystack",
    name: "Paystack",
    description: "Cards, Bank Transfer, USSD",
    icon: "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f9/Paystack_Logo.svg/1280px-Paystack_Logo.svg.png",
    fallbackIcon:
      "https://via.placeholder.com/120x120/00B3B3/FFFFFF?text=Paystack",
    type: "direct",
    color: "#00B3B3",
  },
  square: {
    id: "square",
    name: "Square",
    description: "Credit/Debit Card processing",
    icon: "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3d/Square%2C_Inc._logo.svg/3840px-Square%2C_Inc._logo.svg.png",
    fallbackIcon:
      "https://via.placeholder.com/120x120/1E1E1E/FFFFFF?text=Square",
    type: "direct",
    color: "#1E1E1E",
  },
  // Non-gateway methods (no external logo — react-icons fallback used)
  card: {
    id: "card",
    name: "Credit / Debit Card",
    description: "Pay with credit or debit card",
    type: "direct",
  },
  eft: {
    id: "eft",
    name: "EFT / Bank Transfer",
    description: "Pay via manual electronic funds transfer",
    type: "redirect",
  },
  cod: {
    id: "cod",
    name: "Cash on Delivery",
    description: "Pay cash upon receiving your order",
    type: "direct",
  },
  scan: {
    id: "scan",
    name: "Scan to Pay",
    description: "Scan QR code to pay",
    type: "redirect",
  },
};

export default PAYMENT_GATEWAYS;
